import Vue from 'vue'
import Vuex from 'vuex'

import settings from './modules/settings';
import sidebar from './modules/sidebar';
import dateRangeSettings from './modules/dateRangeSettings';
import auth from './modules/auth';
import appLoader from './modules/appDialogLoader';
import roimaticConfiguration from './modules/roimaticConfiguration';
import featureSettings from './modules/featureSettings';

import { inpaint } from '../features/creativeBuilder/store/Modules/inpaint/index';
import { outpaint } from '../features/creativeBuilder/store/Modules/outpaint/index';

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    auth,
    settings,
    sidebar,
    dateRangeSettings,
    appLoader,
    roimaticConfiguration,
    featureSettings,
    inpaint,
    outpaint
  }
})
